import { useAppContext, useSafeState } from '#hooks';
import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { PlansTableV3 } from '#users/components/plansTableV3.component';
import { AssignEsimMode, DestinationV3, PlanScopeV3, PlanV3, UserV3 } from '#types';
import { dashboardApiV3 } from '#api';
import { AssignEsimModeRadioButtons } from './assignEsimModeRadioButtons.component';
import { AssignEsimConfirmation } from './assignEsimFormConfirmation.component';

interface AssignEsimFormProps {
    user: UserV3;
    setUser: Dispatch<SetStateAction<UserV3>>
    setDisplayAssignEsimForm: Dispatch<SetStateAction<boolean>>
}

export const AssignEsimFormV3: FC<AssignEsimFormProps> = ({ user, setUser, setDisplayAssignEsimForm }) => {

    const { setApiStatus } = useAppContext();
    const [stripeTransactionId, setStripeTransactionId] = useSafeState<string>('');
    const [assignMode, setAssignMode] = useSafeState<AssignEsimMode | undefined>(undefined);
    const [selectedPlan, setSelectedPlan] = useSafeState<PlanV3>({} as PlanV3)
    const [showConfirmation, setShowConfirmation] = useSafeState<boolean>(false)
    const [isLoading, setIsLoading] = useSafeState<boolean>(false)
    const [destinations, setDestinations] = useSafeState<DestinationV3[]>([]);
    const [scope, setScope] = useSafeState<PlanScopeV3>(PlanScopeV3.LOCAL)

    useEffect(
        () => {
            //TODO: handle regional plans
            const fetchDestinations = async () => {
                try {
                    const response = await dashboardApiV3.fetchDestinations();
                    const sorted = response.data.sort((a: DestinationV3, b: DestinationV3) =>
                        a.name.localeCompare(b.name)
                    );
                    setDestinations(sorted);
                } catch { }
            }
            fetchDestinations();
        },
        []
    );

    const handleSubmit = async () => {
        try {
            setIsLoading(true)
            const response = await dashboardApiV3.assignEsim(user.uuid, selectedPlan.nanoID, stripeTransactionId);
            setApiStatus({ code: response.status, message: 'eSIM assigned - please wait a few minutes for the order to fulfil' })
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
            setDisplayAssignEsimForm(false)
        }
    }

    const todaysDate = new Date();
    const maxDate = new Date(todaysDate.getFullYear(), todaysDate.getMonth() + 1, todaysDate.getDate());
    const maxDateString = maxDate.toISOString().split('T')[0];

    if (isLoading) {
        return <div className="lds-hourglass" />
    }

    return <div className='main-dashboard-container pd-m mt-s'>
        <h3 className='mb-m'>Generate order for {user.email}</h3>
        {
            assignMode ?
                showConfirmation ? <AssignEsimConfirmation handleSubmit={handleSubmit} setShowConfirmation={setShowConfirmation} selectedPlan={selectedPlan} email={user.email} stripeTransactionId={stripeTransactionId} /> :
                    <>
                        {
                            assignMode !== AssignEsimMode.NEW_ESIM && <div>
                                <label htmlFor='title'>Stripe Client Reference ID: </label>
                                <input
                                    type='text'
                                    id='notification-title-input'
                                    name='title'
                                    className='pl-m'
                                    value={stripeTransactionId}
                                    onChange={e => setStripeTransactionId(e.target.value)}
                                />
                            </div>
                        }
                        {
                            assignMode !== AssignEsimMode.STRIPE_REPLACE_PLAN &&
                            <PlansTableV3 setSelectedPlan={setSelectedPlan} setShowConfirmation={setShowConfirmation} destinations={destinations} scope={scope} setScope={setScope} />
                        }
                        <div className='three-columns-expand-one mt-m'>
                            <div />
                            <button onClick={() => { setAssignMode(undefined); setDisplayAssignEsimForm(false) }} id='esim-assign-confirmation-button' className='pd-s bold mr-m'>CANCEL</button>
                            {
                                assignMode === AssignEsimMode.STRIPE_REPLACE_PLAN &&
                                <button onClick={handleSubmit} id='esim-assign-confirmation-button' className='pd-s bold mr-m'>SUBMIT</button>
                            }
                        </div>
                    </> :
                <AssignEsimModeRadioButtons assignMode={assignMode} setAssignMode={setAssignMode} />
        }
    </div>
}
